<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label class="label">по рассылке {{campaign.name}}</label>
          <div class="jump-target">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th>Телефон</th>
                <th>Состояние</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="calltask in calltasks">
                <td>
                  <strong v-if="calltask.testing">{{calltask.phone}}</strong>
                  <div v-if="!calltask.testing">{{calltask.phone}}</div>
                  <!--<a :href="'#/calltasks/parameters/'+calltask.id">{{calltask.phone}}</a>-->
                </td>
                <td>
                  <strong v-if="calltask.testing">{{getCallTaskState(calltask.state)}}</strong>
                  <div v-if="!calltask.testing">{{getCallTaskState(calltask.state)}}</div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
            <back-to-top target=".jump-target">
              <button class="button">Наверх</button>
            </back-to-top>
          </div>
          <p class="control">
            <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
              <span>Закрыть</span>
            </button>
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  import { BackToTop } from 'vue-bulma-jump'
  import Vue from 'vue'
  import CheckToken from '../authentication/CheckToken'
  import GetCalltaskState from './GetCalltaskState'

  Vue.mixin(CheckToken)
  Vue.mixin(GetCalltaskState)

  const CALLTASKS_API = '/outgoing-cpg'
  const CAMPAIGNS_API = '/api/campaigns'

  export default {
    props: ['id'],
    components: {
      BackToTop
    },
    data () {
      return {
        calltasks: [],
        campaign: ''
      }
    },
    created: function () {
      this.checkToken()
      this.calltasks = this.loadData()
      this.loadCampaign()
    },
    computed: {
      ...mapGetters([
        'authenticationToken',
        'loggedId'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadApplications () {
          this.loadData()
      },
      loadData () {
        this.$http.get(CALLTASKS_API + '/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.calltasks = response.data
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки телефонных номеров. ')
          })
      },
      loadCampaign () {
        this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.campaign = response.data
          })
      },
      cancel () {
        this.$router.push('/campaigns/' + this.$props.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CalltasksCampaign.vue?262e8528